import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter } from 'next/navigation';
import { useCallback, useEffect } from 'react';
import useGetLoginInfoQuery from '../auth/useGetLoginInfoQuery';
const channelPublicPath = ['notice', 'grade', 'ranking', 'fanRanking', 'signature', 'profile'];
function extractChannelNameFromPath(path: string): string {
  const parts = path.split('/');
  if (parts.length > 2 && parts[1] === 'channel') {
    return parts[2];
  }
  return '';
}
function useChannelTabRedirection() {
  const $ = _c(18);
  const router = useRouter();
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = extractChannelNameFromPath(pathname);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const channelId = t0;
  const {
    userInfo,
    isLogin,
    isLoginInfoLoading
  } = useGetLoginInfoQuery();
  let t1;
  if ($[2] !== channelId || $[3] !== router) {
    t1 = () => router.replace(`/channel/${channelId}/notice`);
    $[2] = channelId;
    $[3] = router;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const redirectToNotice = t1;
  let t2;
  if ($[5] !== channelId || $[6] !== isLogin || $[7] !== isLoginInfoLoading || $[8] !== pathname || $[9] !== redirectToNotice || $[10] !== userInfo?.id) {
    t2 = () => {
      if (isLoginInfoLoading || !channelId) {
        return;
      }
      const isOnPublicPath = channelPublicPath.some(i => pathname.includes(i));
      const isMyChannel = userInfo?.id === channelId;
      if (!isOnPublicPath && (!isLogin || !isMyChannel)) {
        redirectToNotice();
      }
    };
    $[5] = channelId;
    $[6] = isLogin;
    $[7] = isLoginInfoLoading;
    $[8] = pathname;
    $[9] = redirectToNotice;
    $[10] = userInfo?.id;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== isLogin || $[13] !== isLoginInfoLoading || $[14] !== pathname || $[15] !== redirectToNotice || $[16] !== userInfo) {
    t3 = [isLoginInfoLoading, pathname, userInfo, isLogin, redirectToNotice];
    $[12] = isLogin;
    $[13] = isLoginInfoLoading;
    $[14] = pathname;
    $[15] = redirectToNotice;
    $[16] = userInfo;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  useEffect(t2, t3);
}
export default useChannelTabRedirection;